<template>
  <div class="tagInput">
    <input type="text"
      v-model="value"
      :placeholder="placeholder"
      @keyup.enter="onEnter"
    />
  </div>
</template>

<script>
import { ref } from '@vue/composition-api'

export default {
  name: 'TagInput',

  props: {
    placeholder: {
      type: String,
      default: 'Enter Text'
    }
  },

  emits: [
    'action:submit'
  ],

  setup (_, { emit }) {
    const value = ref('')

    const onEnter = () => {
      emit('action:submit', value.value)
      value.value = ''
    }

    return {
      value,
      onEnter
    }
  }
}
</script>

<style lang="scss"></style>
